export const DEFAULT_COMPOSE_TONES = [
  'professional', 'friendly', 'formal', 'casual',
  'executive', 'marketing', 'sales', 'support', 'technical',
];

export const DEFAULT_COMPOSE_LENGTHS = ['short', 'medium', 'long'];

export const DEFAULT_COMPOSE_PURPOSES = [
  'Business', 'Personal', 'Complaint', 'Meeting', 'Invoice', 'Reminder',
  'Thank You', 'Follow-up', 'Apology', 'Offer Letter', 'Leave Request',
  'Interview', 'Job Application', 'Support', 'Promotion', 'Other',
];

export const DEFAULT_LANGUAGES = [
  'Auto', 'English', 'Kannada', 'Hindi', 'Malayalam', 'Tamil',
  'Arabic', 'French', 'German', 'Spanish', 'Japanese',
];

export const EXAMPLE_PROMPTS = [
  'Write a leave request for tomorrow.',
  'Write a quotation email.',
  'Write a follow-up email.',
  'Write an apology email.',
  'Write a meeting request.',
];

const PREFS_KEY = 'aiComposePrefs';

export function loadComposePrefs() {
  try {
    const raw = JSON.parse(localStorage.getItem(PREFS_KEY) || '{}');
    return {
      tone: raw.tone || 'professional',
      language: raw.language || 'Auto',
      length: raw.length || 'medium',
      purpose: raw.purpose || 'Other',
    };
  } catch (_) {
    return {
      tone: 'professional',
      language: 'Auto',
      length: 'medium',
      purpose: 'Other',
    };
  }
}

export function saveComposePrefs(prefs) {
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch (_) { /* ignore */ }
}

export function parseComposeOutput(text) {
  const raw = String(text || '').replace(/\r\n/g, '\n').trim();
  if (!raw) return { subject: '', body: '' };

  const labeled = raw.match(/^SUBJECT:\s*(.+)\s*\n+(?:BODY:\s*\n+)?([\s\S]*)$/i);
  if (labeled) {
    return {
      subject: labeled[1].trim(),
      body: labeled[2].replace(/^BODY:\s*/i, '').trim(),
    };
  }

  const lines = raw.split('\n');
  if (lines.length >= 2 && lines[0].length <= 140) {
    return {
      subject: lines[0].replace(/^SUBJECT:\s*/i, '').trim(),
      body: lines.slice(1).join('\n').replace(/^BODY:\s*/i, '').trim(),
    };
  }

  return { subject: '', body: raw };
}

export function textToHtml(text) {
  if (!text) return '';
  if (/<[a-z][\s\S]*>/i.test(text)) return text;
  return text
    .split(/\n{2,}/)
    .map((p) => `<p>${p.replace(/\n/g, '<br/>')}</p>`)
    .join('');
}

export function stripHtml(html) {
  if (!html) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  return (div.textContent || div.innerText || '').trim();
}

export function hasComposeContent(subject, bodyHtml) {
  const sub = String(subject || '').trim();
  const body = stripHtml(bodyHtml);
  return Boolean(sub || body);
}
